import { Route, Switch } from "react-router-dom";
import { url } from "lcm-iot-commons";

import Legal from "./LegalHTMLfiles/Legal";
import Imprint from "./LegalHTMLfiles/Imprint";

import LegalMarkdownContainer from "./LegalMarkdownContainer";
import { privacyPolicy2025 } from "./LegalMarkdownContent/privacyPolicy2025";
import { privacyPolicy2026 } from "./LegalMarkdownContent/privacyPolicy2026";
import { securityPolicy2026 } from "./LegalMarkdownContent/securityPolicy2026";
import { securityPolicy2022 } from "./LegalMarkdownContent/securityPolicy2022";
import { termsOfService2022 } from "./LegalMarkdownContent/termsOfService2022";
import { serviceLevelAgreement2017 } from "./LegalMarkdownContent/serviceLevelAgreement2017";
import { apiTerms2017 } from "./LegalMarkdownContent/apiTerms2017";
import { definitionProcessWaterRoW2026 } from "./LegalMarkdownContent/definitionProcessWaterRoW2026";

export default function LegalRoutes() {
  return (
    <div className="legal">
      <Switch>
        <Route path={url("/legal")} component={Legal} exact />
        <Route
          path={url("/legal/terms-of-service")}
          render={() => <LegalMarkdownContainer content={termsOfService2022} />}
          exact
        />
        <Route
          path={url("/legal/service-level-agreement")}
          render={() => (
            <LegalMarkdownContainer content={serviceLevelAgreement2017} />
          )}
          exact
        />
        <Route
          path={url("/legal/privacy-policy")}
          render={() => <LegalMarkdownContainer content={privacyPolicy2026} />}
          exact
        />
        <Route
          path={url("/legal/security-policy")}
          render={() => <LegalMarkdownContainer content={securityPolicy2026} />}
          exact
        />
        <Route
          path={url("/legal/definition-netilion-water")}
          render={() => (
            <LegalMarkdownContainer content={definitionProcessWaterRoW2026} />
          )}
          exact
        />
        <Route
          path={url("/legal/archive/privacy-policy-2025")}
          render={() => <LegalMarkdownContainer content={privacyPolicy2025} />}
          exact
        />
        <Route
          path={url("/legal/archive/security-policy-2025")}
          render={() => <LegalMarkdownContainer content={securityPolicy2022} />}
          exact
        />
        <Route
          path={url("/legal/api-terms")}
          render={() => <LegalMarkdownContainer content={apiTerms2017} />}
          exact
        />
        <Route path={url("/legal/imprint")} component={Imprint} exact />
      </Switch>
    </div>
  );
}
